export var InputSize = {
  Sm: 'sm',
  Md: 'md'
};